import React from "react";
import { CartServerSide } from "../../context/api_response";
import { UserContext } from "../../context/user";
import { useHistory } from "react-router-dom";
import { Elements, CardElement, injectStripe } from "react-stripe-elements";
import { ExtraContext } from "../../context/ExtraFunctions";
import HandleSubmitPayment from "../../strapi/handle_order_functions/Server_side_submit";
import { CartContext } from "../../context/cart";
import { Button } from "../Layout/Elements";
import { CheckoutWrapper } from '../Layout/CheckoutWrapper';

const Checkout = (props) => {
  const { total, cart, setCart, userInfo, setForceRerender } = React.useContext(
    CartServerSide
  );
  const { user } = React.useContext(UserContext);
  const {
    get_payment_method,
    flip,
    handleForm,
    authFilters: {
      email,
      Name,
      lastName,
      City,
      ZIP,
      Phone,
      address1,
      address2,
      Note,
    },
    is_empty,
    paymentMethod,
    handleAlert,
    setGif,
    delivery,
  } = React.useContext(ExtraContext);
  const { empty_cart } = React.useContext(CartContext);
  let history = useHistory();

  return (
    <CheckoutWrapper>
      <div className="container py-4">
        <div className="row">
          <div className="col-lg-6 col-12">
            <div className="d-block">
              <div className="mt-5">
                <h4>Delivery Address</h4>
                <div className="borderAll red-border col-lg-4"></div>
              </div>

              <form className="py-4">
                <div className="form-row">
                  <div className="form-group col-md-6">
                    <label>Name*</label>
                    <input
                      className="form-control round-input"
                      type="text"
                      onChange={handleForm}
                      value={Name}
                      name="Name"
                    />
                  </div>

                  <div className="form-group  col-md-6">
                    <label>Last Name*</label>
                    <input
                      className="form-control round-input"
                      onChange={handleForm}
                      value={lastName}
                      type="text"
                      name="lastName"
                    />
                  </div>

                  <div className="form-group col-lg-6 col-12  col-md-6">
                    <label>Email Address*</label>
                    <input
                      type="email"
                      className="form-control round-input"
                      onChange={handleForm}
                      value={email}
                      name="email"
                    />
                  </div>

                  <div className="form-group  col-lg-6 col-12 col-md-6">
                    <label>Phone Number*</label>
                    <input
                      type="number"
                      className="form-control round-input"
                      onChange={handleForm}
                      value={Phone}
                      name="Phone"
                    />
                  </div>

                  <div className="form-group col-lg-12 col-md-6 col-12">
                    <label>Addresses*</label>
                    <input
                      placeholder="Number of apartament"
                      className="form-control round-input"
                      onChange={handleForm}
                      value={address1}
                      type="text"
                      name="address1"
                    />
                  </div>

                  <div className="form-group col-lg-12 col-12 col-md-12">
                    <input
                      placeholder="Extra info, number of apartment(neighbourhood)"
                      className="form-control round-input"
                      type="text"
                      onChange={handleForm}
                      value={address2}
                      name="address2"
                    />
                  </div>

                  <div className="form-group col-lg-6 col-12  col-md-5">
                    <label> ZIP Code* </label>
                    <input
                      className="form-control round-input"
                      type="number"
                      onChange={handleForm}
                      value={ZIP}
                      name="ZIP"
                    />
                  </div>

                  <div className="form-group col-lg-6 col-12  col-md-6 ">
                    <label>City*</label>
                    <input
                      className="form-control round-input"
                      onChange={handleForm}
                      value={City}
                      type="text"
                      name="City"
                    />
                  </div>

                  <div className="form-group col-lg-12">
                    <label>Note about the order</label>

                    <textarea
                      className="form-control round-input"
                      cols="10"
                      rows="5"
                      onChange={handleForm}
                      value={Note}
                      name="Note"
                    ></textarea>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="d-flex   flex-column">
              <h4 className="mt-3">Order Info</h4>
              <div className="borderAll red-border col-lg-4"></div>

              <div className="d-flex flex-column col-lg-8 col-12 p-3 mt-2  card-background">
                <div>
                  <span>Products</span>
                  <div className="borderAll mt-1 mb-1 borderGrey"></div>
                </div>

                {cart.map((item) => {
                  return (
                    <section key={item.id}>
                      <div className="d-flex justify-content-between">
                        <div className="d-flex flex-row align-items-center">
                          <span>{item.amount}X</span>
                          <div className="ml-3"> {item.Title} </div>
                        </div>

                        <div>
                          <h6 className="span-price">
                            ${item.get_size === "small" && item.price_small}
                            {item.get_size === "medium" && item.price_medium}
                            {item.get_size === "large" && item.price_large}
                          </h6>
                        </div>
                      </div>

                      <div className="d-flex flex-column mt-3">
                        <div>
                          <h5>
                            Toppings:
                            <small>{item.toppings}</small>
                          </h5>
                        </div>

                        <div>
                          <h5>
                            Crust:
                            <small className="product-insight">
                              {item.get_crust}
                            </small>
                          </h5>
                        </div>

                        <div>
                          <h5>
                            Size:
                            <small className="product-insight">
                              {item.get_size}
                            </small>
                          </h5>
                        </div>
                      </div>
                    </section>
                  );
                })}

                <div className="checkout-border-line mt-3 col-lg-12"></div>

                <div className="d-flex align-items-center mt-3 justify-content-between">
                  <span>Subtotal</span>
                  <h2>${total}</h2>
                </div>

                <div className="borderAll borderGrey mt-3 col-lg-12"></div>

                <div className="d-flex align-items-center mt-3 justify-content-between">
                  <span>With Delivery</span>
                  <div className="custom-text">{delivery}</div>
                </div>

                <div className="borderAll borderGrey mt-3 col-lg-12"></div>

                <div className="d-flex align-items-center mt-3 justify-content-between">
                  <span>Order Total</span>
                  <h2 className="total">${total}</h2>
                </div>

                <div className="d-flex flex-column mt-3">
                  <div className="d-flex">
                    <div className="form-check">
                      <label className="container-radio">
                        <input
                          onClick={get_payment_method}
                          name="payment"
                          value="In Cash"
                          type="radio"
                        />
                        <span className="checkmark"></span>
                        <span className="ml-3">In cash</span>
                        <div className="d-flex flex-column">
                          <small>Lorem ipsum dolor sit amet.</small>
                        </div>
                      </label>
                    </div>
                  </div>

                  <div className="form-check mt-3">
                    <label className="container-radio">
                      <input
                        onClick={get_payment_method}
                        name="payment"
                        value="Credit Card"
                        type="radio"
                      />

                      <span className="checkmark"></span>
                      <span className="ml-3">Credit Card</span>
                    </label>

                    {flip && (
                      <div className="credit-card-form">
                        <CardElement className="extra-border" />
                      </div>
                    )}
                  </div>
                </div>

                {paymentMethod !== "" && !is_empty ? (
                  <div className="d-flex  mt-3 justify-content-center">
                    <Button
                      onClick={(e) => {
                        HandleSubmitPayment(
                          e,
                          props,
                          paymentMethod,
                          email,
                          Name,
                          lastName,
                          Phone,
                          address1,
                          address2,
                          user,
                          total,
                          Note,
                          City,
                          ZIP,
                          handleAlert,
                          setGif,
                          history,
                          delivery,
                          setForceRerender,
                          cart,
                          setCart,
                          empty_cart,
                          userInfo
                        );
                      }}
                      id="buttoni"
                      type="button"
                      bg="var(--checkoutBtn)"
                      padding="10px"
                      width="100%"
                      opacity="1"
                      color="var(--checkout-btn-text)"
                      fontWeight="bold"
                    >
                      Place order
                    </Button>
                  </div>
                ) : (
                  <div className="d-flex  mt-3 justify-content-center">
                    <Button
                      id="buttoni"
                      type="button"
                      disabled
                      bg="var(--checkoutBtn)"
                      padding="10px"
                      width="100%"
                      opacity="0.6"
                      color="var(--checkout-btn-text)"
                      fontWeight="bold"
                    >
                      Place order
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </CheckoutWrapper>
  );
}

const CardForm = injectStripe(Checkout);

const StripeWrapper = () => {
  return (
    <Elements>
      <CardForm></CardForm>
    </Elements>
  );
};



export default StripeWrapper;
